module.exports = __webpack_public_path__ + "static/wasabi-lg-563f7a3cbc9024e0cd3172151bc824f3.jpg";